import { render, staticRenderFns } from "./addScheme.vue?vue&type=template&id=79e8af21&scoped=true"
import script from "./addScheme.vue?vue&type=script&lang=js"
export * from "./addScheme.vue?vue&type=script&lang=js"
import style0 from "./addScheme.vue?vue&type=style&index=0&id=79e8af21&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e8af21",
  null
  
)

export default component.exports